import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Reveal from '@/components/feature/Reveal';
import ProductsSection from '@/pages/home/components/ProductsSection';

export default function Proyectos() {
  return (
    <div className="min-h-screen bg-background-950">
      <Navbar />
      <main className="pt-32 md:pt-36">
        <section className="px-4 md:px-6 text-center">
          <Reveal>
            <span className="inline-block text-xs md:text-sm font-semibold tracking-widest uppercase text-primary-400">
              Productos y Proyectos
            </span>
            <h1 className="mt-4 text-4xl md:text-5xl font-bold font-heading text-foreground-950 leading-tight tracking-tight">
              Productos que construimos y operamos.
            </h1>
            <p className="mt-5 text-base md:text-lg text-foreground-500 max-w-2xl mx-auto leading-relaxed">
              ACOMA no solo desarrolla software para clientes. También crea y
              opera productos digitales propios, enfrentando los mismos desafíos
              de producto, escalabilidad y operación.
            </p>
          </Reveal>
        </section>
        <ProductsSection />
      </main>
      <Footer />
    </div>
  );
}